import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top on route change, but NOT when only the language segment changes.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prev = useRef(pathname);

  useEffect(() => {
    const stripLang = (p) => {
      // remove leading /ar or /en
      return p.replace(/^\/(ar|en)(?=\/|$)/, '') || '/';
    };
    const prevTail = stripLang(prev.current);
    const nextTail = stripLang(pathname);

    if (prevTail !== nextTail) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }
    prev.current = pathname;
  }, [pathname]);

  return null;
}
